<template>
	<div class="page-container">
		<head-top head-title="收益报表" goBack="true"></head-top>

		<div class="revenue-page">
			<div class="header-section">
				<div class="flex_c">
					<div class="balance-info">
						<div class="balance-label">账户余额($)</div>
						<div class="balance-value">{{ info.withdrawableCommission || '0.00' }}</div>
					</div>
					<div class="withdraw-btn" @click="goWithdraw">去提现</div>
				</div>

				<div class="stats-section flex_b">
					<div class="stat-item">
						<div class="stat-label">累计收益($)</div>
						<div class="stat-value">{{ info.cumulative_commission || '0.00' }}</div>
					</div>
					<div class="stat-item">
						<div class="stat-label">已提现($)</div>
						<div class="stat-value">{{ info.withdrawn_commission || '0.00' }}</div>
					</div>
					<div class="stat-item">
						<div class="stat-label">未结算($)</div>
						<div class="stat-value">{{ info.frozenCommission || '0.00' }}</div>
					</div>
				</div>
			</div>

			<div class="tab-section">
				<van-tabs v-model="activeTab">
					<van-tab title="昨日"></van-tab>
					<van-tab title="本月"></van-tab>
					<van-tab title="上月"></van-tab>
				</van-tabs>
			</div>

			<div class="content-section">
				<div class="order-card bg_a">
					<div class="card-content flex_c">
						<div class="item">
							<van-popover v-model="showOrderCountPopover" trigger="click" overlay placement="bottom-start">
								<div class="pop-content">{{ ['昨日','本月','上月'][activeTab] }}付款笔数：{{ ['昨日','本月','上月'][activeTab] }}所有付款的订单数量，只包含有效订单</div>
								<template #reference>
									<div class="item-label">
										付款笔数
										<van-icon name="question-o" />
									</div>
								</template>
							</van-popover>
							<div class="item-value">{{ info[tabFields[activeTab].count] || 0 }}</div>
						</div>

						<div class="item">
							<van-popover v-model="showOrderRevenuePopover" trigger="click" overlay placement="bottom-end">
								<div class="pop-content">{{ ['昨日','本月','上月'][activeTab] }}预估收益：{{ ['昨日','本月','上月'][activeTab] }}创建的所有有效订单预估收益</div>
								<template #reference>
									<div class="item-label">
										预估收益
										<van-icon name="question-o" />
									</div>
								</template>
							</van-popover>
							<div class="item-value">${{ info[tabFields[activeTab].revenue] || '0.00' }}</div>
						</div>
					</div>
				</div>

				<div class="menu-item bg_a flex_c" @click="goBalanceDetail">
					<div class="menu-text">余额明细</div>
					<van-icon name="arrow" />
				</div>

				<div class="menu-item bg_a flex_c" @click="goWithdrawRecords">
					<div class="menu-text">提现记录</div>
					<van-icon name="arrow" />
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import headTop from '@/components/common/head.vue'
	import { getLoginMember ,getCommissionReportInfo } from '@/apis/api.js'
	export default {
		name: 'RevenueReport',
		components: {
			headTop
		},
		data() {
					return {
						activeTab: 0,
						info: {},
						showOrderCountPopover: false,
						showOrderRevenuePopover: false,
						tabFields: [
							{ count: 'yesterdayTotalTradeNum', revenue: 'yesterdayEstimateCommission' },
							{ count: 'currentMonthTotalTradeNum', revenue: 'currentMonthCommission' },
							{ count: 'lastMonthTotalTradeNum', revenue: 'lastMonthCommission' }
						]
					}
				},
		mounted() {
			this.loadData()
		},
		methods: {
			loadData() {
						if (!getLoginMember()) {
							this.$router.push('/login?redirect=' + encodeURIComponent(this.$route.fullPath))
							return
						}
						this.$toast.loading({ message: '加载中...', duration: 0 })
						getCommissionReportInfo().then(res => {
							this.info = res || {}
						}).catch(e => {
							if (e.handled) return
							this.$toast(e.msg || '加载失败')
						}).finally(() => {
							this.$toast.clear()
						})
					},
			goWithdraw() {
				this.$router.push('/withdraw')
			},
			goBalanceDetail() {
				this.$router.push('/balance_detail')
			},
			goWithdrawRecords() {
				this.$router.push('/records')
			}
		}
	}
</script>

<style lang="scss" scoped>
	.page-container {
		padding-top: 48px;

		.revenue-page {
			.header-section {
				background: linear-gradient(180deg, #FEEAB8 0%, #F9D976 100%);
				padding: 20px 14px;

				.balance-info {
					flex: 1;

					.balance-label {
						font-size: 14px;
						color: #666;
						margin-bottom: 10px;
					}

					.balance-value {
						font-size: 20px;
						font-weight: bold;
						color: #333;
					}
				}

				.withdraw-btn {
					flex: none;
					background: rgba(255, 255, 255, .7);
					border-radius: 20px;
					padding: 0 16px;
					font-size: 14px;
					color: #333;
					height: 30px;
					line-height: 30px;
					cursor: pointer;
				}

				.stats-section {
					margin-top: 20px;
					background: #fff;
					border-radius: 8px;
					padding: 16px 14px;

					.stat-item {
						width: 33.3%;
						text-align: center;

						.stat-label {
							width: 100%;
							font-size: 12px;
							color: #999;
							margin-bottom: 6px;
						}

						.stat-value {
							width: 100%;
							font-size: 16px;
							font-weight: bold;
							color: #333;
						}
					}
				}
			}

			.tab-section {
				:deep(.van-tab) {
					font-size: 14px;
				}

				:deep(.van-tab--active) {
					color: #333;
					font-weight: bold;
				}
			}

			.content-section {
				padding:16px 14px 0;

				:deep(.van-dropdown-menu__bar) {
					box-shadow: none;
					height: auto;
				}
				:deep(.van-dropdown-menu){
					padding-right: 7.5px;
				}

				:deep(.van-dropdown-menu__title::after) {
					border-color: transparent transparent #323233 #323233;
				}

				:deep(.van-dropdown-menu__title--active::after) {
					border-color: transparent transparent #ee0a24 #ee0a24;
				}

				.order-card {
					border-radius: 8px;
					padding:16px 14px;
					margin-bottom: 16px;

					.card-content {
						.item {
							width: 50%;
							text-align: center;

							.item-label {
								width: 100%;
								font-size: 13px;
								color: #999;
								margin-bottom: 8px;
							}

							.item-value {
								width: 100%;
								font-size: 16px;
								font-weight: bold;
								color: #333;
							}
						}
					}
				}

				.menu-item {
					padding: 16px 14px;
					border-radius: 8px;
					margin-bottom: 16px;
					
					&.menu-item:last-child{
						margin-bottom: 0;
					}

					.menu-text {
						font-size: 14px;
						color: #333;
					}

					.van-icon {
						font-size: 16px;
						color: #ccc;
					}
				}
			}
		}
	}
	.pop-content{
		padding:14px;
		font-size:12px;
		line-height:1.5;
		max-width:200px;
	}
</style>